const translations = {
  "en": {
    "+{count} more": "+{count} more",
    "Generate my score": "Generate my score",
    "Generate your real Fitness Score?": "Generate your real Fitness Score?",
    "This replaces your quick-read with the real number.": "This replaces your quick-read with the real number."
  },
  "zh-tw": {
    "+{count} more": "+{count} 項更多",
    "Generate my score": "生成我的評分",
    "Generate your real Fitness Score?": "生成你的真實財務健康分數？",
    "This replaces your quick-read with the real number.": "這會用真實數字取代你先前的快速估算。"
  }
};

export default translations;
